export default __webpack_public_path__ + "static/media/cardcont2.4e4aea4a.png";